<template>
  <v-container fluid>
    <v-text-field
      class="my-5"
      outlined
      counter
      v-model="search"
      append-icon="mdi-magnify"
      label="Search"
      single-line
      :rules="[
        (v) =>
          (v && v.length >= 3) || 'Description must be 3 characters or more',
      ]"
    ></v-text-field>
    <v-data-table
      class="elevation-10"
      :headers="headers"
      :items="items"
      :search="searchTrigger"
      :expanded.sync="expanded"
      :single-expand="singleExpand"
      :loading="myloadingvariable"
      loading-text="Loading... Please wait"
      show-expand
      item-key="id"
      multi-sort
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50],
      }"
    >
      <template #item.imagelink="{ item }">
        <v-icon @click="redirect(item.imagelink)"> mdi-download-box </v-icon>
      </template>
      <template #item.postmockup="{ item }">
        <v-icon @click="copy(item)">
          mdi-clipboard-check-multiple-outline
        </v-icon>
      </template>
      <!-- <template v-for="header in headers" #[`item.${header.value}`]="{ value }">
        <v-chip
          style="white-space: wrap"
          :key="header.id"
          :color="CheckNull(value)"
        >
          {{ value }}
        </v-chip>
      </template> -->
      <template #expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <div
            v-for="(value, name) in item"
            v-bind:key="value"
            v-bind:value="value"
          >
            <h2>{{ name }}:</h2>
            {{ value }}
          </div>
        </td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
const axios = require("axios");

export default {
  name: "App",
  computed: {
    searchTrigger() {
      if (this.search.length >= 3) {
        return this.search;
      }
    },
  },
  created() {
    if (this.getCookie() === "true") {
      this.GetSoci();
    } else {
      this.$router.push("/");
    }
  },
  methods: {
    copy(item) {
      
      let testurl = "https://www.hommati.com/3DTour-AerialVideo/"+item.address.split(' ').join('-')+"--HPI"+item.id
      let mockup = "🏡 " + item.description + "\n" + "📍 "+ item.address +", " +item.city+", "+ item.state+" "+item.zipcode+ "\n" + 
      "View listing at: \n"+testurl+"\n" +
      "Listed by: " + item.agent_name + " with " + item.agent_company + "\n" +
      "📸 By: @Hommati"+item.code +"\n"
      // Copy the text inside the text field
      navigator.clipboard.writeText(mockup);
    },
    redirect(url) {
      window.open(url, "_blank").focus();
    },
    getCookie() {
      const cookieValue = document.cookie
        .split("; ")
        .find((row) => row.startsWith("HommatiSociLoggedIn="))
        ?.split("=")[1];
      return cookieValue;
    },
    makeHeaders() {
      Object.keys(this.items[0]).forEach((header) => {
        if (header === "updated_at" || header === "description") {
          return;
        } else {
          this.headers.push({
            text: header.toString(),
            value: header,
            align: "center",
          });
        }
      });
    },
    // CheckNull(CheckIfNull) {
    //   if (CheckIfNull === null || CheckIfNull === "") return "red";
    //   else return "green";
    // },
    async GetSoci() {
      this.myloadingvariable = true;
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: "https://apibox.hommati.cloud/ajax/marketing/soci_updates",
        headers: {
          accept: "application/json",
        },
      };
      axios
        .request(config)
        .then((response) => {
          // console.log(response.data);
          response.data.forEach((item) => {
            item.imagelink =
              "https://apibox.hommati.cloud/ajax/marketing/get_images/" +
              item.id;
            item.postmockup = ""
            this.items.push(item);
            // console.log(item.GetImageLink)
          });
          this.makeHeaders();
          this.myloadingvariable = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  data: () => ({
    expanded: [],
    singleExpand: true,
    search: "",
    headers: [],
    myloadingvariable: false,
    items: [],
  }),
};
</script>

<style>
/* Header */
.v-data-table-header {
  background-color: orange;
  text-transform: uppercase;
  font-weight: bolder;
}
/* Header Cell Css */
.v-data-table th {
  border: 1px solid black;
}
/* Alternate Row Color */
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.3);
}
/* Footer */
.v-data-footer {
  background-color: orange;
  text-transform: uppercase;
  font-weight: bolder;
}
/* Cell Css */
.v-data-table td {
  border: 1px solid black;
  font-weight: bold;
}
/* Bad CSS for cell padding ? */

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  padding: 0 0px;
}
</style>
